export const drawArea = (
  context,
  obj,
  canvasOffset,
  zoom,
  selectedArea,
  seatingTickets
) => {
  const centerX = obj.x + obj.width / 2;
  const centerY = obj.y + obj.height / 2;
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };
  const assigned = findTicket(obj.tierID);

  context.save(); // Save the current state
  context.scale(zoom, zoom);
  context.translate(centerX + canvasOffset.x, centerY + canvasOffset.y); // Move to the center of the rectangle
  context.rotate((obj.rotation * Math.PI) / 180); // Rotate around the center
  if (
    selectedArea.find((o) => {
      return o.id === obj.id;
    })
  ) {
    context.strokeStyle = "black"; // Set border color
    context.lineWidth = 5; // Set border width
    context.strokeRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height); // Draw the border
  }

  // Draw the rectangle
  if (assigned) context.fillStyle = obj.tierColor ? obj.tierColor : obj.color;
  else context.fillStyle = "black";
  context.fillRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);

  // Before drawing the text, rotate back to cancel out the rectangle's rotation
  // context.rotate((-obj.rotation * Math.PI) / 180); // Inverse rotation for the text
  const newFont = zoom >= 0.1 ? 12 / zoom : 12;
  context.fillStyle = "white"; // Set text color
  context.font = `700 ${newFont}px Arial`; // Set font size and family
  context.textAlign = "center"; // Center the text horizontally
  context.textBaseline = "middle"; // Center the text vertically
  context.fillText(obj.name, 0, 0); // Draw the text at the rectangle's center
  const additionalText = `Capacity: ${obj.capacity}`; // Replace with the desired text
  const lineHeight = 20; // Adjust the line height as needed
  const yOffset = lineHeight; // Adjust the Y offset based on the font size and line height
  // context.fillText(additionalText, 0, yOffset); // Draw the additional text below obj.name text

  context.restore(); // Restore the initial context state
};
